import { UNUSED_BUNDLE_NAME } from 'cadenza/workbook/model/attribute-bundle-name';
import type { AttributeBundleReference } from 'cadenza/workbook/workbook-panel/settings/attributes/compatible-bundle-provider';

import i18n from './unused-bundle-reference.properties';

export const UNUSED_BUNDLE_REFERENCE: AttributeBundleReference = { name: UNUSED_BUNDLE_NAME, title: i18n('title') };
